//
//
//
//
//
//
//
//
//
//
//
//
//
//

import questionItem from "../answer_components/question_item"
import answeredItem from "../answer_components/answered_item"
export default {
    components: {
        questionItem,
        answeredItem
    },
    props: {
        finish: Boolean,
        current_question: Object,
        answered_questions: Array
    },
    watch: {
        finish() {
            this.$emit('submit')
        }
    },
    methods: {
        removeOpt (i) {
            this.$emit('removeAnswer', i)
        },
        selectOpt (item) {
            this.$emit('addAnswer', item)
        }
    }
}
